import styled from "styled-components"

export const HistoryListWrapper = styled.div`
`
export const HistoryWrapper = styled.div`
    & > ${HistoryListWrapper} {
        padding-left: 40px;
        margin-bottom: 30px;
    }
`
export const History = styled.div`
    width: fit-content;
    min-width: 50%;
    margin-bottom: 8px;
    padding: 6px 12px;
    border-radius: 5px;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    background: ${(props) => props.theme.nestedHistoryBackgroundColor};
    color: ${(props) => props.theme.nestedHistoryColor};
`


export const TitleRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    color: ${(props) => props.theme.nestedHistoryTitleColor}; // date time color
`
export const Title = styled.div`
    margin-right: 20px;
    border-bottom: 1px dashed ${(props) => props.theme.nestedHistoryTitleBorderColor};
    color: ${(props) => props.theme.nestedHistoryApprovalLevelColor}; // dash color
`
export const DraftSaved = styled.span`
    font-size: 14px;
`
export const Author = styled.span`
    color: ${(props) => props.theme.nestedHistoryAuthorColor};
`
export const ApprovalLevel = styled.span`
    color: ${(props) => props.theme.nestedHistoryApprovalLevelColor};
`
export const Answer = styled.div`
    white-space: break-spaces;
`
export const Response = styled.div`
    white-space: break-spaces;
`
export const NextRevision = styled.div`
`
export const Remark = styled.div`
    white-space: break-spaces;
`
export const Attachment = styled.div`
`
export const Status = styled.div`
`
export const Workflow = styled.div`
    margin-top: 5px;
    color: ${(props) => props.theme.nestedHistoryWorkflowColor};
`
export const Bold = styled.b`
    margin-right: 5px;
    color: ${(props) => props.theme.nestedHistoryBoldColor};
`

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: end;
`
